import EmojiPicker from 'emoji-picker-react'
import FilterBackButton from 'assets/images/new-images/filter-back-button.svg'

import React, { useState, useRef, useEffect, useContext } from 'react'
import {
  Avatar,
  Upload,
  Tooltip,
  Button,
  message,
  Modal,
  Tabs,
  Drawer,
  Select,
  Spin,
} from 'antd'
import {
  PaperClipOutlined,
  SmileOutlined,
  SendOutlined,
  CloseOutlined,
  EyeOutlined,
  DeleteOutlined,
  CheckOutlined,
} from '@ant-design/icons'
import FilterBackIcon from 'assets/images/new-images/filter-back-button.svg'
import { Mentions } from 'antd'
import { useMutation, useQuery, useSubscription } from '@apollo/react-hooks'
import {
  GET_MESSAGES,
  GET_CHAT_PARTICIPANTS,
  GET_MESSAGES_FOR_EXPORT,
} from '../graphql/Queries'
import { MARK_MESSAGES_AS_READ, SEND_MESSAGE } from '../graphql/Mutations'
import {
  MESSAGE_SUBSCRIPTION,
  MESSAGE_READ_SUBSCRIPTION,
} from '../graphql/subscription'
import { AppContext } from 'AppContext'
import moment from 'moment'
import client from 'apollo'
import { GET_USERS_FOR_SELECT } from 'modules/Users/graphql/Queries'
import {
  ADD_CHAT_PARTICIPANT,
  DELETE_CHAT_PARTICIPANT,
} from '../Settings/graphql/Mutations'
import {
  canUserEdit,
  canUserAdd,
  canUserDelete,
  canUserExport,
  canUserDownload,
} from 'utils/User'
import DocumentViewerModal from 'components/DocumentViewerModal'


const { Option } = Mentions
const TabPane = Tabs.TabPane

export default function TicketChatPanel({ ticket, setChatAttachments }) {
  const ticketId = window.location.pathname.split('/').slice(-1)[0]
  const [attachments, setAttachments] = useState([])
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState(null)
  const [previewTitle, setPreviewTitle] = useState('')
  const [hoveredAttachment, setHoveredAttachment] = useState(null)
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)
  const [exporting, setExporting] = useState(false)


  const [selectedTab, setSelectedTab] = useState('CLIENT')

  const [userData, setUserData] = useState([])
  const [userLoading, setUserLoading] = useState(false)
  const [selectedUserId, setSelectedUserId] = useState('')

  const fetchUsers = () => {
    setUserLoading(true)
    client
      .query({
        query: GET_USERS_FOR_SELECT,
        variables: {
          where: {
            // role: ['STAFF', 'SALES_EXECUTIVE', 'ADMIN'],
            isActive: 'true',
          },
          limit: 100000,
        },
      })
      .then((res) => {
        setUserData(res?.data?.getUsers?.users || [])
        setUserLoading(false)
      })
      .catch((err) => {
        setUserLoading(false)
      })
  }

  useEffect(() => {
    fetchUsers()
  }, [])

  const changeTab = (key, tab) => {
    if (key === '1') {
      setSelectedTab('INTERNAL')
    } else if (key === '2') {
      setSelectedTab('CLIENT')
    }
  }

  const {
    state: {
      currentUser,
      userPermissions,
      isClient,
    } = {},
  } = useContext(AppContext) || {}
  const id = currentUser?.id
  const role = currentUser?.role
  const canEdit = canUserEdit(userPermissions || currentUser, isClient)
  const canAdd = canUserAdd(userPermissions || currentUser, isClient)
  const canDelete = canUserDelete(userPermissions || currentUser, isClient)
  const canExport = canUserExport(userPermissions || currentUser, isClient)
  const canDownload = canUserDownload(userPermissions || currentUser, isClient)
  const [docViewer, setDocViewer] = useState({
    visible: false,
    fileUrl: '',
    title: '',
  })


  const getTick = (msg) => {
    if (msg.sender.id !== id) return null

    let seenByAssignee = false
    let assigneeName = ''

    // If it's a CLIENT tab, check only assignUser
    if (selectedTab === 'CLIENT' && ticket?.assignUser?.id) {
      const assigneeId = ticket.assignUser.id
      const assigneeRead = msg.readBy?.find((u) => u.id === assigneeId)
      if (assigneeRead) {
        seenByAssignee = true
        assigneeName = `${assigneeRead.firstName} ${assigneeRead.lastName}`
      }
    } else {
      // fallback: original logic (for team/internal)
      seenByAssignee = msg.status === 'read'
    }

    return (
      <Tooltip
        visible={false}
        title={
          seenByAssignee
            ? `Seen by: ${
                assigneeName || msg.readBy?.map((u) => u.firstName).join(', ')
              }`
            : 'Not seen yet'
        }
      >
        {seenByAssignee ? (
          <span style={{ color: '#AF0000' }}>
            {' '}
            <svg
              viewBox='0 0 16 11'
              height='11'
              width='16'
              preserveAspectRatio='xMidYMid meet'
              class=''
              fill='none'
            >
              <path
                d='M11.0714 0.652832C10.991 0.585124 10.8894 0.55127 10.7667 0.55127C10.6186 0.55127 10.4916 0.610514 10.3858 0.729004L4.19688 8.36523L1.79112 6.09277C1.7488 6.04622 1.69802 6.01025 1.63877 5.98486C1.57953 5.95947 1.51817 5.94678 1.45469 5.94678C1.32351 5.94678 1.20925 5.99544 1.11192 6.09277L0.800883 6.40381C0.707784 6.49268 0.661235 6.60482 0.661235 6.74023C0.661235 6.87565 0.707784 6.98991 0.800883 7.08301L3.79698 10.0791C3.94509 10.2145 4.11224 10.2822 4.29844 10.2822C4.40424 10.2822 4.5058 10.259 4.60313 10.2124C4.70046 10.1659 4.78086 10.1003 4.84434 10.0156L11.4903 1.59863C11.5623 1.5013 11.5982 1.40186 11.5982 1.30029C11.5982 1.14372 11.5348 1.01888 11.4078 0.925781L11.0714 0.652832ZM8.6212 8.32715C8.43077 8.20866 8.2488 8.09017 8.0753 7.97168C7.99489 7.89128 7.8891 7.85107 7.75791 7.85107C7.6098 7.85107 7.4892 7.90397 7.3961 8.00977L7.10411 8.33984C7.01947 8.43717 6.97715 8.54508 6.97715 8.66357C6.97715 8.79476 7.0237 8.90902 7.1168 9.00635L8.1959 10.0791C8.33132 10.2145 8.49636 10.2822 8.69102 10.2822C8.79681 10.2822 8.89838 10.259 8.99571 10.2124C9.09304 10.1659 9.17556 10.1003 9.24327 10.0156L15.8639 1.62402C15.9358 1.53939 15.9718 1.43994 15.9718 1.32568C15.9718 1.1818 15.9125 1.05697 15.794 0.951172L15.4386 0.678223C15.3582 0.610514 15.2587 0.57666 15.1402 0.57666C14.9964 0.57666 14.8715 0.635905 14.7657 0.754395L8.6212 8.32715Z'
                fill='currentColor'
              ></path>
            </svg>
          </span>
        ) : (
          <span style={{ color: '#A1A1A1' }}>
            <svg
              viewBox='0 0 16 11'
              height='11'
              width='16'
              preserveAspectRatio='xMidYMid meet'
              class=''
              fill='none'
            >
              <path
                d='M11.0714 0.652832C10.991 0.585124 10.8894 0.55127 10.7667 0.55127C10.6186 0.55127 10.4916 0.610514 10.3858 0.729004L4.19688 8.36523L1.79112 6.09277C1.7488 6.04622 1.69802 6.01025 1.63877 5.98486C1.57953 5.95947 1.51817 5.94678 1.45469 5.94678C1.32351 5.94678 1.20925 5.99544 1.11192 6.09277L0.800883 6.40381C0.707784 6.49268 0.661235 6.60482 0.661235 6.74023C0.661235 6.87565 0.707784 6.98991 0.800883 7.08301L3.79698 10.0791C3.94509 10.2145 4.11224 10.2822 4.29844 10.2822C4.40424 10.2822 4.5058 10.259 4.60313 10.2124C4.70046 10.1659 4.78086 10.1003 4.84434 10.0156L11.4903 1.59863C11.5623 1.5013 11.5982 1.40186 11.5982 1.30029C11.5982 1.14372 11.5348 1.01888 11.4078 0.925781L11.0714 0.652832ZM8.6212 8.32715C8.43077 8.20866 8.2488 8.09017 8.0753 7.97168C7.99489 7.89128 7.8891 7.85107 7.75791 7.85107C7.6098 7.85107 7.4892 7.90397 7.3961 8.00977L7.10411 8.33984C7.01947 8.43717 6.97715 8.54508 6.97715 8.66357C6.97715 8.79476 7.0237 8.90902 7.1168 9.00635L8.1959 10.0791C8.33132 10.2145 8.49636 10.2822 8.69102 10.2822C8.79681 10.2822 8.89838 10.259 8.99571 10.2124C9.09304 10.1659 9.17556 10.1003 9.24327 10.0156L15.8639 1.62402C15.9358 1.53939 15.9718 1.43994 15.9718 1.32568C15.9718 1.1818 15.9125 1.05697 15.794 0.951172L15.4386 0.678223C15.3582 0.610514 15.2587 0.57666 15.1402 0.57666C14.9964 0.57666 14.8715 0.635905 14.7657 0.754395L8.6212 8.32715Z'
                fill='currentColor'
              ></path>
            </svg>
          </span>
        )}
      </Tooltip>
    )
  }

  const [messages, setMessages] = useState([])
  const [inputValue, setInputValue] = useState('')
  const [isFocused, setIsFocused] = useState(false)
  const [isTyping, setIsTyping] = useState(false)
  const [showSendAnimation, setShowSendAnimation] = useState(false)
  const [chatRoomId, setChatRoomId] = useState(null)
  const [hasMore, setHasMore] = useState(true)
  const [loadingMore, setLoadingMore] = useState(false)
  const [offset, setOffset] = useState(0)
  const [isInitialLoad, setIsInitialLoad] = useState(true)
  const inputRef = useRef(null)
  const chatBodyRef = useRef(null)
  const messagesEndRef = useRef(null)
  const [mentioned, setMentioned] = useState([])

  const [participantsSettingOpen, setParticipantsSettingOpen] = useState(false)

  const handleDeleteParticipant = async (userId) => {
    if (!canDelete) return
    await client.mutate({
      mutation: DELETE_CHAT_PARTICIPANT,
      variables: {
        chatRoomId: +chatRoomId,
        userId: +userId,
      },
    })
    refetch()
    message.success('Participant removed!')
  }

  const handleAddParticipant = async () => {
    if (!canAdd && !canEdit) return
    if (!selectedUserId) return
    await client.mutate({
      mutation: ADD_CHAT_PARTICIPANT,
      variables: {
        chatRoomId: +chatRoomId,
        userId: +selectedUserId,
      },
    })
    refetch()
    message.success('Participant added!')
    setSelectedUserId('')
  }

  //const isCoreParticipant = (user, ticket) => {
  //  return (
  //    user.id === ticket.assignUser?.id || // Assignee
  //    user.role === 'ADMIN' || // Admin
  //    user.role === 'CLIENT' || // Client
  //    user.id === ticket.team?.teamLeader?.id || // Team Leader
  //    user.id === ticket.department?.head?.id // Department Head
  //  )
  //}

  const MESSAGES_LIMIT = 20

  // Fetch initial messages
  const { loading, error, fetchMore } = useQuery(GET_MESSAGES, {
    variables: {
      ticketId,
      type: selectedTab,
      offset: 0,
      limit: MESSAGES_LIMIT,
    },
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (data?.chatMessages?.messages) {
        setMessages(data.chatMessages.messages)
        setChatRoomId(data.chatMessages.room.id)
        setHasMore(data.chatMessages.messages.length === MESSAGES_LIMIT)
        setOffset(data.chatMessages.messages.length)
        setIsInitialLoad(false)
        setChatAttachments(data.chatMessages.attachments)

        // Scroll only if near bottom
        setTimeout(() => scrollToBottom(false), 100)
      }
    },
  })
  console.log('messages', messages)
  console.log('chatRoomId', chatRoomId)

  const {
    data: participantsData,
    refetch,
    loading: participantsLoading,
  } = useQuery(GET_CHAT_PARTICIPANTS, {
    variables: {
      chatRoomId, // assuming you have the chatRoomId variable defined
    },
    skip: !chatRoomId,
  })

  const handleExportChat = async () => {
    if (!canExport) return
    try {
      setExporting(true)
      const { data } = await client.query({
        query: GET_MESSAGES_FOR_EXPORT,
        variables: {
          ticketId,
          type: selectedTab,
        },
        fetchPolicy: 'network-only',
      })

      const allMessages = data?.chatMessagesForExport?.messages || []

      const transcript = allMessages
        .map(
          (msg) =>
            `${msg.sender.firstName} ${msg.sender.lastName} (${moment(
              msg.createdAt
            ).format('YYYY-MM-DD hh:mm:ss A')}): ${msg.message || ''} ${
              msg.attachments.length > 0
                ? `[Attachments => ${msg.attachments?.join(', ')}]`
                : ''
            }`
        )
        .join('\n')

      const blob = new Blob([transcript], { type: 'text/plain' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `chat-transcript-${ticketId}.txt`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
      setExporting(false)
    } catch (err) {
      setExporting(false)
      message.error('Failed to export chat')
      console.error('Export chat error:', err)
    }
  }

  const mentionOptions =
    participantsData?.chatParticipants?.map((user) => ({
      id: user.id,
      name: `${user.firstName} ${user.lastName}`,
      firstName: user.firstName,
      lastName: user.lastName,
    })) || []

  // Subscription for read receipts
  useSubscription(MESSAGE_READ_SUBSCRIPTION, {
    variables: { chatRoomId },
    skip: !chatRoomId,
    onSubscriptionData: ({ subscriptionData }) => {
      const event = subscriptionData?.data?.messageRead
      if (!event) return
      setMessages((prev) =>
        prev.map((msg) => {
          if (event.messageIds.includes(msg.id)) {
            const updatedReadBy =
              event.readBy.find((r) => r.messageId === msg.id)?.users ||
              msg.readBy
            // Keep the status from the backend instead of forcing 'read'
            return { ...msg, readBy: updatedReadBy }
          }
          return msg
        })
      )
    },
  })

  const [markMessagesAsRead] = useMutation(MARK_MESSAGES_AS_READ)

  useEffect(() => {
    if (chatRoomId) {
      markMessagesAsRead({ variables: { chatRoomId } })
    }
  }, [chatRoomId, markMessagesAsRead])

  // Subscription for new messages
  const { data: subscriptionData } = useSubscription(MESSAGE_SUBSCRIPTION, {
    variables: { chatRoomId },
    skip: !chatRoomId,
    onSubscriptionData: ({ subscriptionData }) => {
      console.log('Subscription data received:', subscriptionData)
      const msg = subscriptionData?.data?.messageAdded // ✅ define msg here
      if (msg) {
        setMessages((prev) => [...prev, msg])
        setChatAttachments((prev) => [...prev, ...msg.attachments])

        if (msg.sender.id !== id) {
          markMessagesAsRead({ variables: { chatRoomId } })
        }
        // Auto scroll to bottom when new message arrives
        if (isUserNearBottom()) {
          setTimeout(() => scrollToBottom(), 100)
        }
      } else {
        console.warn('No messageAdded data in subscription response')
      }
    },
    onError: (err) => {
      console.error('Subscription error:', err)
      message.error('Failed to receive real-time updates')
    },
  })

  console.log('subscriptionData', subscriptionData)

  const [sendMessage] = useMutation(SEND_MESSAGE)

  // Auto scroll to bottom function
  const isUserNearBottom = () => {
    if (!chatBodyRef.current) return false
    const { scrollTop, scrollHeight, clientHeight } = chatBodyRef.current
    return scrollHeight - scrollTop - clientHeight < 100
  }

  const scrollToBottom = (smooth = true) => {
    if (!messagesEndRef.current) return
    requestAnimationFrame(() => {
      messagesEndRef.current.scrollIntoView({
        behavior: smooth ? 'smooth' : 'auto',
        block: 'nearest',
      })
    })
  }

  // Load more messages (pagination)
  const loadMoreMessages = async () => {
    if (loadingMore || !hasMore) return

    setLoadingMore(true)
    try {
      const { data: moreData } = await fetchMore({
        variables: {
          ticketId,
          type: selectedTab,
          offset: offset,
          limit: MESSAGES_LIMIT,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          // Apollo requires this function, even if we don’t use the result
          return prev
        },
      })

      const newMessages = moreData?.chatMessages?.messages || []

      if (newMessages.length === 0) {
        setHasMore(false)
      } else {
        setMessages((prev) => [...newMessages, ...prev])
        setOffset((prev) => prev + newMessages.length)
      }
    } catch (error) {
      console.error('Error loading more messages:', error)
      message.error('Failed to load more messages')
    } finally {
      setLoadingMore(false)
    }
  }

  // Handle scroll event for pagination
  const handleScroll = (e) => {
    const { scrollTop } = e.target
    // Load more when scrolled to top
    if (scrollTop === 0 && hasMore && !loadingMore) {
      loadMoreMessages()
    }
  }
  const groupMessagesByDate = (messages) => {
    const groups = messages.reduce((acc, msg) => {
      const dateKey = moment(msg.createdAt).format('YYYY-MM-DD')
      if (!acc[dateKey]) {
        acc[dateKey] = []
      }
      acc[dateKey].push(msg)
      return acc
    }, {})

    return Object.keys(groups).map((dateKey) => ({
      date: dateKey,
      messages: groups[dateKey],
    }))
    // .sort((a, b) => moment(b.date).diff(moment(a.date))); // Sort descending (newest first)
  }

  const isImageFile = (fileNameOrType = '') => {
    return /\.(jpeg|jpg|png|gif|webp|ico|bmp|svg)$/i.test(fileNameOrType)
  }

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }

  const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase()
    const iconMap = {
      pdf: '📄',
      doc: '📝',
      docx: '📝',
      xls: '📊',
      xlsx: '📊',
      ppt: '📽️',
      pptx: '📽️',
      txt: '📄',
      zip: '🗜️',
      rar: '🗜️',
      mp4: '🎥',
      mp3: '🎵',
      wav: '🎵',
    }
    return iconMap[extension] || '📎'
  }

  useEffect(() => {
    if (inputValue.length > 0 && !isTyping) {
      setIsTyping(true)
    } else if (inputValue.length === 0 && isTyping) {
      setIsTyping(false)
    }
  }, [inputValue, isTyping])

  const handleSend = async () => {
    if (!inputValue.trim() && attachments.length === 0) return

    setShowSendAnimation(true)
    try {
      //      // Extract mentions from input
      // const mentions = inputValue
      //   .match(/@[\w\s]+/g)
      //   ?.map((mention) => mention.slice(1))
      //   .map((name) => {
      //     const user = mentionOptions.find((opt) => opt.name === name)
      //     return user ? user.id : null
      //   })
      //   .filter(Boolean)

      // Prepare attachments for upload
      const filesToSend = attachments.map((fileObj) => fileObj.originFileObj)

      await sendMessage({
        variables: {
          input: {
            message: inputValue,
            mentions: mentioned,
            attachments: filesToSend, // [Upload] type
            chatRoomId: chatRoomId,
          },
        },
      })

      setMentioned([])
      setInputValue('')
      setShowSendAnimation(false)
      setIsTyping(false)
      setAttachments([]) // Clear attachments after send

      // Auto scroll to bottom after sending
      setTimeout(() => scrollToBottom(), 100)
    } catch (error) {
      console.error('Error sending message:', error)
      message.error('Failed to send message')
      setShowSendAnimation(false)
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  // Enhanced attachment upload handler
  const handleUpload = async ({ file }) => {
    const maxSize = 10 * 1024 * 1024 // 10MB

    // Destroy existing messages to avoid stacking
    message.destroy()

    if (file.size > maxSize) {
      message.error('File size must be less than 10MB')
      return
    }

    setAttachments((prev) => {
      const isDuplicate = prev.some(
        (f) => f.name === file.name && f.size === file.size
      )

      if (isDuplicate) {
        // message.warning('File already attached')
        return prev
      }

      message.success(`${file.name} attached successfully`)
      return [...prev, file]
    })
  }

  const highlightMentions = (text, mentions) => {
    if (!mentions || mentions.length === 0) return text

    const mentionNames = mentions.map((m) =>
      `@${m.firstName} ${m.lastName}`.trim()
    )

    const mentionRegex = new RegExp(`(${mentionNames.join('|')})`, 'gi')

    const parts = text.split(mentionRegex)

    return parts.map((part, idx) => {
      const match = mentionNames.find(
        (name) => name.toLowerCase() === part.toLowerCase()
      )
      return match ? (
        <span key={idx} style={{ fontWeight: 700, color: '#AF0000' }}>
          {part}
        </span>
      ) : (
        part
      )
    })
  }

  // Remove specific attachment
  const handleRemoveAttachment = (index) => {
    const removedFile = attachments[index]
    setAttachments((prev) => prev.filter((_, i) => i !== index))
    message.success(`${removedFile.name} removed`)
  }

  // Clear all attachments
  const handleClearAllAttachments = () => {
    setAttachments([])
    message.success('All attachments cleared')
  }

  // Preview attachment
  const handlePreviewAttachment = (file, fileName) => {
    setPreviewImage(file)
    setPreviewTitle(fileName)
    setPreviewVisible(true)
  }

  if (error) {
    message.error('Failed to load messages')
    console.error('Query error:', error)
  }

  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 12,
        boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #F2F2F2',
        overflowY: 'auto',
      }}
    >
      {/* Header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '8px 16px 0 16px',
          borderBottom: '1px solid #F2F2F2',
        }}
      >
        <div style={{ display: 'flex' }}>
          <img
            onClick={() => window.history.back()}
            style={{ cursor: 'pointer', marginRight: '32px' }}
            src={FilterBackIcon}
            alt=''
          />{' '}
          {role === 'CLIENT' ? (
            <span
              className='gx-chat-contact-name'
              style={{
                fontSize: '18px',
                color: '#000000',
                fontWeight: 600,
              }}
            >
              {'Chat'}
            </span>
          ) : (
            <Tabs defaultActiveKey='2' onChange={changeTab}>
              <TabPane tab='Team' key='1' />
              <TabPane tab='Client' key='2' />
            </Tabs>
          )}
        </div>
        <div style={{ flex: 1 }} />
        {role !== 'CLIENT' && canExport && (
          <Button
            loading={exporting}
            onClick={handleExportChat}
            type='default'
            style={{
              borderRadius: 8,
              background: '#F7F7F7',
              color: '#222',
              fontWeight: 500,
              border: 'none',
              height: 36,
              marginTop: 8,
              // transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#EEEEEE'
              e.target.style.transform = 'translateY(-1px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#F7F7F7'
              e.target.style.transform = 'translateY(0)'
            }}
          >
            Export Chat
          </Button>
        )}
        {role !== 'CLIENT' && selectedTab !== 'CLIENT' && (
          <Button
            onClick={() => setParticipantsSettingOpen(true)}
            style={{
              height: 36,
              marginTop: 8,
              marginLeft: '8px',
              fontSize: '14px',
              fontWeight: '600',
              lineHeight: '24px',
              textAlign: 'left',
              color: '#AF0000',
              background: '#AF00000D',
              border: '1px solid #AF000080',
              borderRadius: '8px',
            }}
          >
            Participant Settings
          </Button>
        )}
      </div>

      <Drawer
        title={null}
        headerStyle={{ display: 'none' }}
        closable={false}
        placement='right'
        onClose={() => setParticipantsSettingOpen(false)}
        visible={participantsSettingOpen}
        width={472}
      >
        <div
          style={{
            margin: '32px 0 24px 0',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <div onClick={() => setParticipantsSettingOpen(false)}>
            <img src={FilterBackButton} alt='FilterBackButton' />
          </div>
          <div
            style={{
              fontSize: '24px',
              fontWeight: '700',
              lineHeight: '28px',
              textAlign: 'left',
              color: '#000000',
              marginLeft: '16px',
            }}
          >
            Participant Settings
          </div>
        </div>

        {participantsLoading && <Spin />}
        <div style={{ marginLeft: 16 }}>
          {/* List participants */}
          {participantsData?.chatParticipants?.map((user) => (
            <div
              key={user.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 12,
              }}
            >
              <Avatar
                style={{
                  backgroundColor: '#AF0000',
                  color: '#fff',
                  fontWeight: 700,
                  marginRight: 12,
                }}
              >
                {user.firstName[0]}
                {user.lastName?.trim()?.length ? user.lastName?.trim()[0] : ''}
              </Avatar>
              <input
                value={`${user.firstName} ${user.lastName || ''}`}
                disabled
                style={{
                  flex: 1,
                  border: '1px solid #eee',
                  borderRadius: 4,
                  padding: '6px 12px',
                  fontSize: 15,
                  background: '#fafafa',
                  marginRight: 8,
                }}
              />

              {canDelete && (
                <DeleteOutlined
                  style={{ color: '#AF0000', fontSize: 20, marginRight: 8, cursor: 'pointer' }}
                  onClick={() => handleDeleteParticipant(user.id)}
                />
              )}
            </div>
          ))}
          {/* Add participant */}
          {(canAdd || canEdit) && (
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 16 }}>
              <Select
                showSearch
                loading={userLoading}
                placeholder='Select User'
                value={selectedUserId || undefined}
                optionFilterProp='children'
                filterOption={(input, option) => {
                  const user = userData.find((u) => u.id === option.value)
                  if (!user) return false
                  const searchText = `${user.firstName} ${user.lastName || ''} ${
                    user.role
                  }`.toLowerCase()
                  return searchText.includes(input.toLowerCase())
                }}
                allowClear
                style={{ flex: 1, marginRight: 8 }}
                onChange={(val) => setSelectedUserId(val)}
              >
                {userData.map((user) => (
                  <Select.Option value={user.id} key={user.id}>
                    <span
                      style={{ display: 'flex', justifyContent: 'space-between' }}
                    >
                      <span>
                        {user.firstName} {user.lastName || ''}
                      </span>
                      <span
                        style={{
                          marginLeft: 8,
                          color: '#999',
                          fontStyle: 'italic',
                        }}
                      >
                        ({user.role})
                      </span>
                    </span>
                  </Select.Option>
                ))}
              </Select>
              <CheckOutlined
                onClick={handleAddParticipant}
                style={{ fontSize: 20 }}
              />
              <DeleteOutlined
                style={{
                  color: '#AF0000',
                  fontSize: 20,
                  marginLeft: 8,
                  marginRight: 8,
                }}
                onClick={() => setSelectedUserId('')}
              />
              {/* <Button
                type='text'
                icon={<span style={{ color: '#AF0000', fontSize: 20 }}>✔</span>}
                disabled={!selectedUserId}
                onClick={handleAddParticipant}
              /> */}
            </div>
          )}
        </div>
      </Drawer>

      {/* Enhanced Preview Modal */}
      <Modal
        visible={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        centered
        width='fit-content'
        title={previewTitle}
        bodyStyle={{
          padding: 20,
          background: '#fafafa',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          alt='preview'
          style={{
            maxHeight: '70vh',
            maxWidth: '80vw',
            objectFit: 'contain',
            borderRadius: 8,
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          }}
          src={previewImage}
        />
      </Modal>

      {/* Chat Body */}
      <div
        ref={chatBodyRef}
        onScroll={handleScroll}
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '24px 0 24px 0',
          background: '#fff',
          position: 'relative',
        }}
      >
        {/* Loading indicator for pagination */}
        {loadingMore && (
          <div
            style={{
              textAlign: 'center',
              padding: '16px',
              color: '#666',
              fontSize: 14,
            }}
          >
            Loading more messages...
          </div>
        )}

        {/* Load more button (alternative to auto-load) */}
        {hasMore && !loadingMore && !isInitialLoad && (
          <div style={{ textAlign: 'center', padding: '16px' }}>
            <Button
              type='link'
              onClick={loadMoreMessages}
              style={{ fontSize: 13, color: '#AF0000' }}
            >
              Load older messages
            </Button>
          </div>
        )}

        {loading && isInitialLoad && (
          <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
            Loading messages...
          </div>
        )}

        {groupMessagesByDate(messages).map(({ date, messages: msgs }) => (
          <div key={date}>
            <div
              style={{
                textAlign: 'center',
                margin: '16px 0',
                color: '#999',
                fontSize: 14,
              }}
            >
              {moment(date).isSame(moment(), 'day')
                ? 'Today'
                : moment(date).format('DD/MM/YYYY')}
            </div>
            {msgs.map((msg, idx) => (
              <div
                key={msg.id}
                className='message-slide-in'
                style={{
                  display: 'flex',
                  flexDirection: msg.sender.id === id ? 'row-reverse' : 'row',
                  alignItems: 'flex-start',
                  marginBottom: 32,
                  padding: '0 32px',
                  // animationDelay: `${idx * 0.1}s`,
                }}
              >
                <Avatar
                  style={{
                    backgroundColor: '#AF0000',
                    fontWeight: 600,
                    fontSize: 18,
                    margin: msg.sender.id === id ? '0 0 0 16px' : '0 16px 0 0',
                    transition: 'all 0.3s ease',
                  }}
                >
                  {msg.sender.firstName[0]}
                </Avatar>
                <div style={{ maxWidth: 420, width: 'fit-content' }}>
                  <div
                    style={{
                      fontSize: 13,
                      color: '#A1A1A1',
                      display: 'flex',
                      marginBottom: 4,
                      textAlign: msg.sender.id === id ? 'right' : 'left',
                      fontWeight: 500,
                      justifyContent:
                        msg.sender.id === id ? 'flex-end' : 'flex-start',
                    }}
                  >
                    <div style={{ marginRight: '5px' }}>
                      {msg.sender.id === id
                        ? ''
                        : `${msg.sender.firstName || ''} ${
                            msg.sender.lastName || ''
                          }`}
                    </div>{' '}
                    {moment(msg.createdAt).format('hh:mm A')}
                  </div>
                  {msg.message?.length > 0 && (
                    <div
                      style={{
                        background:
                          msg.sender.id === id ? '#FFF0F0' : '#F7F7F7',
                        color: msg.sender.id === id ? '#AF0000' : '#222',
                        borderRadius:
                          msg.sender.id === id
                            ? '8px 8px 0 8px'
                            : '8px 8px 8px 0',
                        padding: '12px 16px',
                        fontSize: 15,
                        fontWeight: 400,
                        marginBottom: msg.attachments?.length ? 12 : 0,
                        boxShadow:
                          msg.sender.id === id ? '0 1px 4px #FFD6D6' : 'none',
                        border:
                          msg.sender.id === id
                            ? '1px solid #FFD6D6'
                            : '1px solid #F2F2F2',
                        whiteSpace: 'pre-line',
                        transition: 'all 0.3s ease',
                      }}
                    >
                      {highlightMentions(msg.message, msg.mentions)}
                    </div>
                  )}
                  {msg.attachments?.length > 0 &&
                    msg.attachments?.map((item) => (
                      <div key={item} style={{ marginTop: 8 }}>
                        {isImageFile(item) ? (
                          <img
                            src={item}
                            alt='attachment'
                            style={{
                              maxWidth: 260,
                              borderRadius: 12,
                              boxShadow: '0 2px 8px #eee',
                              cursor: 'pointer',
                              transition: 'transform 0.3s ease',
                            }}
                            onClick={() => {
                              setPreviewImage(item)
                              setPreviewTitle(item.split('/').pop())
                              setPreviewVisible(true)
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.transform = 'scale(1.02)'
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.transform = 'scale(1)'
                            }}
                          />
                        ) : (
                          <div
                            onClick={() =>
                              setDocViewer({
                                visible: true,
                                fileUrl: item,
                                title: item.split('/').pop() || 'Attachment Preview',
                              })
                            }
                            style={{

                              display: 'flex',
                              alignItems: 'center',
                              gap: 8,
                              background: '#FAFAFA',
                              border: '1px solid #EEE',
                              padding: '6px 12px',
                              borderRadius: 8,
                              fontSize: 13,
                              maxWidth: 260,
                              wordBreak: 'break-all',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease',
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = '#F0F0F0'
                              e.target.style.transform = 'translateY(-1px)'
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = '#FAFAFA'
                              e.target.style.transform = 'translateY(0)'
                            }}
                          >
                            {getFileIcon(item)} {item.split('/').pop()}
                          </div>
                        )}
                      </div>
                    ))}
                  <div style={{ textAlign: 'right', marginTop: 2 }}>
                    {getTick(msg)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}

        {/* Invisible element to scroll to */}
        <div ref={messagesEndRef} />
      </div>

      {/* Enhanced Attachments Preview Section */}
      {attachments.length > 0 && (
        <div
          style={{
            padding: '16px 24px',
            borderTop: '1px solid #F2F2F2',
            background: '#FAFAFA',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: 12,
            }}
          >
            <span style={{ fontSize: 14, fontWeight: 500, color: '#666' }}>
              Attachments ({attachments.length})
            </span>
            <Button
              type='text'
              size='small'
              icon={<DeleteOutlined />}
              onClick={handleClearAllAttachments}
              style={{ color: '#AF0000', fontSize: 12 }}
            >
              Clear All
            </Button>
          </div>
          <div
            style={{
              display: 'flex',
              gap: 12,
              flexWrap: 'wrap',
              maxHeight: 200,
              overflowY: 'auto',
            }}
          >
            {attachments.map((file, i) => {
              const fileUrl = URL.createObjectURL(file.originFileObj || file)
              const isImage = isImageFile(file.name || file.type)

              return (
                <div
                  key={i}
                  style={{
                    position: 'relative',
                    width: 120,
                    height: 100,
                    border: '2px solid #E6E6E6',
                    borderRadius: 12,
                    overflow: 'hidden',
                    background: '#fff',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                  }}
                  onMouseEnter={() => setHoveredAttachment(i)}
                  onMouseLeave={() => setHoveredAttachment(null)}
                  onClick={() =>
                    isImage && handlePreviewAttachment(fileUrl, file.name)
                  }
                >
                  {/* Remove button */}
                  <div
                    style={{
                      position: 'absolute',
                      top: 4,
                      right: 4,
                      background: '#FF4D4F',
                      borderRadius: '50%',
                      width: 20,
                      height: 20,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      zIndex: 2,
                      opacity: hoveredAttachment === i ? 1 : 0.7,
                      transition: 'opacity 0.2s ease',
                    }}
                    onClick={(e) => {
                      e.stopPropagation()
                      handleRemoveAttachment(i)
                    }}
                  >
                    <CloseOutlined style={{ fontSize: 10, color: '#fff' }} />
                  </div>

                  {/* Preview button for images */}
                  {isImage && (
                    <div
                      style={{
                        position: 'absolute',
                        top: 4,
                        left: 4,
                        background: 'rgba(0,0,0,0.6)',
                        borderRadius: '50%',
                        width: 20,
                        height: 20,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        zIndex: 2,
                        opacity: hoveredAttachment === i ? 1 : 0,
                        transition: 'opacity 0.2s ease',
                      }}
                      onClick={(e) => {
                        e.stopPropagation()
                        handlePreviewAttachment(fileUrl, file.name)
                      }}
                    >
                      <EyeOutlined style={{ fontSize: 10, color: '#fff' }} />
                    </div>
                  )}

                  {isImage ? (
                    <img
                      src={fileUrl}
                      alt={file.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.3s ease',
                        transform:
                          hoveredAttachment === i ? 'scale(1.05)' : 'scale(1)',
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        padding: 8,
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        fontSize: 11,
                        background:
                          hoveredAttachment === i ? '#F5F5F5' : '#FAFAFA',
                        transition: 'background 0.2s ease',
                      }}
                      onClick={() =>
                        setDocViewer({
                          visible: true,
                          fileUrl: fileUrl,
                          title: file.name || 'File Preview',
                        })
                      }
                    >
                      <div style={{ fontSize: 24, marginBottom: 4 }}>
                        {getFileIcon(file.name)}
                      </div>
                      <div
                        style={{
                          wordBreak: 'break-word',
                          lineHeight: 1.2,
                          maxHeight: 32,
                          overflow: 'hidden',
                        }}
                      >
                        {file.name}
                      </div>
                      <div style={{ fontSize: 9, color: '#999', marginTop: 2 }}>
                        {formatFileSize(file.size)}
                      </div>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      )}

      {/* Enhanced Input Section */}
      <div
        style={{
          borderTop: '1px solid #F2F2F2',
          display: 'flex',
          alignItems: 'center',
          height: '50px',
          width: '100%',
        }}
      >
        {selectedTab === 'CLIENT' ? (
          <input
            ref={inputRef}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyPress={handleKeyPress}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            placeholder='Type your message...'
            style={{
              border: 'none',
              outline: 'none',
              fontSize: 15,
              boxShadow: 'none', // Remove the default box-shadow
              transition: 'all 0.3s ease',
              width: '100%',
              // padding: '0 16px',
              margin: '0 16px',
            }}
          />
        ) : (
          <Mentions
            ref={inputRef}
            value={inputValue}
            onChange={(val) => {
              console.log('-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-')
              console.log('val', val)
              setInputValue(val)
            }}
            onKeyPress={handleKeyPress}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            onSelect={(option) => {
              console.log('-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-')
              console.log('option', option)
              setMentioned((prev) => [...prev, option?.id])
            }}
            placeholder='Type @ for mention'
            className={`
            ${isFocused ? 'chat-input-focused' : 'chat-input-blurred'}
            ${isTyping ? 'chat-input-typing' : ''}
          `}
            style={{
              border: 'none',
              outline: 'none !important',
              fontSize: 15,
              boxShadow: 'none',
              transition: 'all 0.3s ease',
              width: '100%',
              // padding: '0 16px',
              margin: '0 16px',
            }}
          >
            {mentionOptions.map(({ id, name }) => (
              <Option key={id} id={id} value={name}>
                {name}
              </Option>
            ))}
          </Mentions>
        )}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '24px',
            padding: '0 8px',
          }}
        >
          <Upload
            showUploadList={false}
            onChange={handleUpload}
            // multiple
            // beforeUpload={() => false} // Prevent auto upload
          >
            <Tooltip title='Attach files'>
              <PaperClipOutlined
                className='icon-hover'
                style={{
                  fontSize: 18,
                  color: attachments.length > 0 ? '#AF0000' : '#A1A1A1',
                  cursor: 'pointer',
                  transition: 'color 0.3s ease',
                }}
              />
            </Tooltip>
          </Upload>
          <div style={{ position: 'relative' }}>
            <Tooltip title='Emoji'>
              <SmileOutlined
                onClick={() => setShowEmojiPicker((prev) => !prev)}
                style={{
                  fontSize: 18,
                  color: '#A1A1A1',
                  cursor: 'pointer',
                }}
              />
            </Tooltip>

            {showEmojiPicker && (
              <div
                style={{
                  position: 'absolute',
                  bottom: 40,
                  right: 0,
                  zIndex: 9999,
                }}
              >
                <EmojiPicker
                  onEmojiClick={(emojiData) => {
                    setInputValue((prev) => prev + emojiData.emoji)
                    setShowEmojiPicker(false)
                  }}
                  theme='light'
                  height={350}
                  width={300}
                />
              </div>
            )}
          </div>
        </div>
        <button
          onClick={handleSend}
          disabled={
            !inputValue.trim() &&
            attachments.length === 0 &&
            showSendAnimation === false
          }
          style={{
            height: '100%',
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            width: '50px',
            opacity: !inputValue.trim() && attachments.length === 0 ? 0.5 : 1,
            transition: 'opacity 0.3s ease',
          }}
        >
          <SendOutlined
            style={{
              fontSize: 16,
              color:
                inputValue.trim() || attachments.length > 0
                  ? '#AF0000'
                  : '#A1A1A1',
              transition: 'color 0.3s ease',
            }}
          />
        </button>
      </div>
      <DocumentViewerModal
        visible={docViewer.visible}
        fileUrl={docViewer.fileUrl}
        title={docViewer.title}
        onClose={() => setDocViewer({ visible: false, fileUrl: '', title: '' })}
        canDownload={canDownload}
        watermark={
          !canDownload
            ? `CONFIDENTIAL AUDIT • ${currentUser?.userName || 'AUDIT'} • ${moment().format('DD-MMM-YYYY')}`
            : ''
        }
      />
    </div>
  )
}
